import { render, staticRenderFns } from "./GradeItem.vue?vue&type=template&id=f8fe71de&scoped=true&"
import script from "./GradeItem.vue?vue&type=script&lang=js&"
export * from "./GradeItem.vue?vue&type=script&lang=js&"
import style0 from "./GradeItem.vue?vue&type=style&index=0&id=f8fe71de&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fe71de",
  null
  
)

export default component.exports